/* eslint-disable max-len */
export default {
    one: {
        section: {
            title: 'Jak skorzystasz <strong>na partnerstwie</strong> z Lemlock?'
        },
        button: 'Dowiedz się więcej o Lemlock',
        icons: [{
            align: 'right',
            title: 'Specjaliści trzech branż',
            title_2_lines: 'Specjaliści<br/> trzech branż',
            desc: 'Lemlock to synergia płynąca z połączenia kompetencji testerów bezpieczeństwa, prawników oraz inżynierów oprogramowania.'
        }, {
            align: 'right',
            title: 'Nadzór i testy weryfikacyjne',
            title_2_lines: 'Nadzór i testy<br/> weryfikacyjne',
            desc: 'Zespół Lemlock sprawuje nadzór podczas wprowadzania zmian do Twojej infrastruktury, oprogramowań czy systemów informatycznych. Po przeprowadzonych testach weryfikacyjnych zyskujesz pewność, że naniesione poprawki lub ulepszenia będą kompatybilne z dokumentacją/raportem z badań stanu bezpieczeństwa pod względem prawnym i technicznym.'
        }, {
            align: 'right',
            title: 'Metodologia i kompetencje',
            title_2_lines: 'Metodologia<br> i kompetencje',
            desc: 'Testy i audyty Lemlock prowadzone są według wytycznych OWASP i NIST oraz spełniają standardy ISO 27000. Testerzy posiadają certyfikaty ABW potwierdzające wiarygodność, a nad całym procesem czuwa kancelaria prawna.'
        }, {
            align: 'right',
            title: 'Aktywny Monitoring',
            title_2_lines: 'Aktywny<br> Monitoring',
            desc: 'Ciągłość bezpieczeństwa danych bez względu na pojawiające się zagrożenia wymaga stałego, aktywnego monitoringu. Lemlock jest jak alarm, który poinformuje Cię o każdym wykrytym zagrożeniu.'
        }, {
            align: 'left',
            title: 'Start w 48h',
            title_2_lines: 'Start<br/> w 48h',
            desc: 'Uruchomienie procesu testowania w niecałe dwie doby jest możliwe. Gwarancja szybkiego startu i dostęp do postępów prac pozwalają kontrolować cały proces na bieżąco.'
        }, {
            align: 'left',
            title: 'Certyfikaty Bezpieczeństwa',
            title_2_lines: 'Certyfikaty<br/> Bezpieczeństwa',
            desc: 'Lemlock standard, Lemlock platinum i certyfikat zgodności z RODO pomogą Ci zwiększyć wiarygodność i zaufanie wśród klientów, partnerów biznesowych i pracowników.'
        }]
    },
    two: {
        section: {
            title: 'Proces naszej pracy krok po kroku:'
        },
        icons: [
            'zgłoszenie',
            'konsultacja',
            'monitoring',
            'raport',
            'nadzór',
            'certyfikat'
        ],
        bonus: '<span>BONUS:</span> Bezpłatne konsultacje z ekspertem w zakresie wdrażania lub modyfikacji zabezpieczeń.'
    },
    three: {
        button: 'Zabezpiecz swoje aplikacje i zasoby cyfrowe',
        section: {
            title: 'W jaki sposób udowodnisz,<br/> że <strong>dobrze zabezpieczasz</strong> dane?',
            desc: '<p>Współczesny klient to osoba coraz bardziej świadoma swoich praw w zakresie ochrony danych osobowych. Firmy i instytucje gromadzące lub przetwarzające dane zyskują dużą przewagę udowadniając, że do kwestii bezpieczeństwa podchodzą poważnie.</p><p>Korzystając z rozwiązań Lemlock, możesz w łatwy sposób zakomunikować Twoim klientom, partnerom biznesowym i pracownikom, że stosujesz odpowiednie zabezpieczenia.</p>'
        },
        boxes: [{
            title: 'Lemlock STANDARD',
            textTop: 'test penetracyjny<br/> audyt bezpieczeństwa',
            textBottom: 'sprawdzono poziom zabezpieczeń i usunięto wykryte luki'
        }, {
            title: 'Lemlock PLATINIUM',
            textTop: 'monitoring sieci<br/> i serwerów',
            textBottom: 'prowadzony jest stały monitoring i natychmiastowa korekcja pojawiających się podatności'
        }, {
            title: 'Certyfikat zgodności z RODO',
            textTop: 'audyt zgodności<br/> z RODO',
            textBottom: 'wdrożono zmiany zgodnie z wytycznymi RODO'
        }]
    },
    general: {
        cybersecurity_title: 'Cyberbezpieczeństwo oprogramowania i aplikacji',
        consulting_title: 'Konsulting prawny i techniczny',
        read_more: 'Czytaj dalej',
        back: 'Powrót',
        button1: 'Określ swoje potrzeby',
        button2: 'Uzyskaj bezpłatną konsultację'
    },
    clients: {
        title: 'Zaufali nam'
    },
    list: [{
        slug: 'application-security-audits-penetration-tests',
        title: 'Audyty bezpieczeństwa i Testy penetracyjne',
        subtitle: 'Dowiedz się o błędach w Twoich systemach, aplikacjach internetowych oraz aplikacjach server-side.',
        icon: 'icon01',
        content: {
            title: 'Audyty bezpieczeństwa i Testy penetracyjne',
            subtitle: 'aby wykryć słabe punkty aplikacji i systemów IT',
            text: [
                'Przeprowadzenie kontrolowanych prób ataków na Twoje aplikacje i systemy IT. Takie symulacje ataków hakerskich to doskonały sposób na sprawdzenie, czy dane są bezpieczne.',
                'W przeciwieństwie do prawdziwego ataku, testy penetracyjne oraz audyty są wykorzystywane zarówno do wskazywania wyraźnych nieprawidłowości, jak i tych, które są ukryte i ledwo zauważalne. Głównym celem jest przede wszystkim przeprowadzenie dokładnego procesu poszukiwania podatności, a nie koncentrowanie się na pierwszej napotkanej luce.',
                'Zespół Lemlock w Twoim imieniu może nadzorować wprowadzanie do Twoich systemów IT oraz aplikacji niezbędnych korekt czy ulepszeń na podstawie wygenerowanego raportu z opisami zidentyfikowanych podatności: ich rodzajem, złożonością oraz wagą.'
            ],
            icons_title: 'Audyty opierają się na standardach <b>OWASP</b> oraz <b>OWASP Mobile</b> i są dostosowane do ochrony Twoich:',
            icons: [{
                icon: 'web',
                title: 'Aplikacji Webowych'
            }, {
                icon: 'server',
                title: 'Aplikacji Server-Side/Cloud'
            }, {
                icon: 'important',
                title: 'Aplikacji Mobilnych'
            }]
        },
        cta: [{
            text: 'Cennik',
            icon: 'get',
            page: 'estimation'
        }, {
            text: 'Pobierz broszurę',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/pl/Audyty_bezpieczenstwa_i_Testy_penetracyjne.pdf`
        }, {
            text: 'Zapytaj o szczegóły',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'application-gdpr-compliant-audits',
        title: 'Audyt Zgodności aplikacji z RODO',
        subtitle: 'Sprawdź, czy Twoje aplikacje webowe, mobilne i server-side spełniają techniczne i prawne wymagania nowego rozporządzenia Unii Europejskiej.',
        icon: 'icon02',
        content: {
            title: 'Audyt Zgodności aplikacji z RODO',
            subtitle: 'aby Twoja aplikacja była zgodna z nowym prawem UE w zakresie ochrony prywatności',
            icons_title: 'Szczegółowy audyt zgodności dla Twoich:',
            icons: [{
                icon: 'web',
                title: 'Aplikacji Webowych'
            }, {
                icon: 'server',
                title: 'Aplikacji Server-Side/Cloud'
            }, {
                icon: 'important',
                title: 'Aplikacji Mobilnych'
            }],
            list_numbered_title: 'Biorąc pod uwagę trzy perspektywy:',
            list_numbered: [{
                title: 'Prawną',
                text: 'Prawnicy specjalizujący się w branży IT identyfikują dane osobowe, oceniają ryzyko związane z ich przetwarzaniem w oparciu o standard <b>ISO 27000</b> i - w razie potrzeby - analizują warunki korzystania z usług w ramach aplikacji.  '
            }, {
                title: 'Inżynieryjną',
                text: 'Architekci systemów i inżynierowie oprogramowania analizują architekturę aplikacji za pośrednictwem kodu źródłowego, aby sprawdzić, czy spełniane są przepisy RODO, a jeśli nie są, dostarczają oni odpowiednie zalecenia.'
            }, {
                title: 'Cyberbezpieczeństwa',
                text: 'Eksperci ds. Bezpieczeństwa weryfikują, czy dane osobowe i wszelkie mechanizmy utworzone w ramach RODO są właściwie zabezpieczone.'
            }],
            list_numbered_text: 'Eksperci Lemlock są w stanie nadzorować proces wdrażania rekomendowanych  mechanizmów ochrony i koniecznych poprawek pod względem prawnym, dzięki czemu zostanie zmniejszone ryzyko naruszenia lub utraty danych.'
        },
        cta: [{
            text: 'Cennik',
            icon: 'get',
            page: 'estimation'
        }, {
            text: 'Pobierz broszurę',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/pl/Audyt_Zgodnosci_aplikacji_z_RODO.pdf`
        }, {
            text: 'Zapytaj o szczegóły',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'continuous-pentesting',
        title: 'Continuous Pentesting & RODO',
        subtitle: 'Każda modyfikacja aplikacji ze stałą kontrolą cyberbezpieczeństwa.',
        icon: 'icon03',
        content: {
            title: 'Continuous Pentesting & RODO',
            subtitle: 'Dodawanie nowych funkcji do aplikacji z ciągłą weryfikacją cyberbezpieczeństwa i zgodności z RODO\n',
            text: [
                'Twoja firma stale się rozwija, podobnie jak Twoje rozwiązania IT. Aby Twój produkt był atrakcyjny dla wciąż zmieniającego się rynku, musisz dodawać do niego nowe funkcje. Jednak w momencie jakiejkolwiek modyfikacji systemu istnieje ryzyko pojawienia się nowej podatności lub niezgodności z RODO. Oczywiście, że przed wydaniem nowej wersji aplikacji możesz zamówić<span class="offer-details-blue"> audyt bezpieczeństwa lub zgodności z RODO</span>, ale może to okazać się czasochłonne i kosztowne. Zamiast tego warto rozważyć usługę Continuous Pentesting i zgodności z RODO Twojego systemu. ',
                'Dzięki usłudze Continuous Pentesting & RODO, Twoje rozwiązanie zostanie objęte procesem, będzie zawierał w sobie: ',
                [
                    'bieżące kontrole bezpieczeństwa,',
                    'bieżące techniczne kontrole RODO,',
                    'doradztwo w zakresie bezpieczeństwa dla zespołu programistów,',
                    'szybkie powiadomienia o wykrytych naruszeniach i lukach w zabezpieczeniach,',
                    'natychmiastową korektę środków bezpieczeństwa,',
                    'ciągłe monitorowanie luk w zabezpieczeniach bibliotek open source, których używasz,',
                    'weryfikację integralności środowiska produkcyjnego systemu.'
                ],
                '\n' +
                'Bezpieczeństwo danych i aplikacji jest procesem nieprzerwanym, dlatego warto zapewnić bezpieczeństwo procesowi Ciągłego Dostarczania wraz z zespołem Lemlock. Twój zespół będzie mógł w każdej chwili poprosić o wsparcie eksperta ds. Bezpieczeństwa, dzięki czemu szybciej zostaną rozwiązane problemy z zakresu bezpieczeństwa, a także zostanie zmniejszone prawdopodobieństwo powstania nowych luk.',
                'Ponadto integralność środowiska produkcyjnego może być stale monitorowana, co pomoże szybciej wykryć, czy aplikacja została zmodyfikowana (zmienione konto bankowe, zmiany treści, niewidzialne iniekcje skryptów ze złośliwym oprogramowaniem, które infekują komputery pracowników i Klientów), a tym samym zapobiegać stratom finansowym i reputacji.'
            ]
        },
        cta: [{
            text: 'Cennik',
            icon: 'get',
            page: 'estimation'
        }, {
            text: 'Pobierz broszurę',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/pl/Monitoring_Bezpieczenstwa_Aplikacji.pdf`
        }, {
            text: 'Zapytaj o szczegóły',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'risk-management-security-policy',
        title: 'Zarządzanie ryzykiem i polityki bezpieczeństwa',
        subtitle: 'Dostosuj polityki bezpieczeństwa Twojej organizacji do stopnia ryzyka posiadanych zasobów IT.',
        icon: 'icon04',
        content: {
            title: 'Zarządzanie ryzykiem i polityki bezpieczeństwa',
            subtitle: 'aby dokonać oceny ryzyka zasobów cyfrowych należących do Twojej organizacji i zapewnić odpowiednie środki do zarządzania nim',
            text: [
                'Sprawdź, jakie rodzaje danych w ramach zasobów cyfrowych (serwerów, baz danych, aplikacji) są przetwarzane w organizacji. Zyskaj wiedzę na temat działań, jakie należy podjąć, aby odpowiednio zabezpieczyć zasoby bez względu na to, czy są one związane z:',
                [
                    'danymi osobowymi (RODO),',
                    'know how, przepisami i tajemnicą handlową,',
                    'listą płac czy wynagrodzeniami.'
                ],
                'Proces ten będzie przeprowadzony zgodnie z <span class="offer-details-blue">ISO 2700x, RODO</span> i innymi obowiązującymi przepisami prawnymi.',
                'Eksperci Lemlock mogą nadzorować proces wdrażania rekomendowanych zmian do strategii Zarządzania ryzykiem i do polityk bezpieczeństwa oraz wesprzeć budowanie świadomości organizacji w tych kwestiach.'
            ]
        },
        cta: [{
            text: 'Cennik',
            icon: 'get',
            page: 'estimation',
            hash: 'decrease'
        }, {
            text: 'Pobierz broszurę',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/pl/Zarzadzanie_ryzykiem_i_polityki_bezpieczenstwa.pdf`
        }, {
            text: 'Zapytaj o szczegóły',
            icon: 'ask',
            page: 'contact'
        }]
    }, {
        slug: 'incident-handling-and-post-breach-analysis',
        title: 'Obsługa incydentów i analiza powłamaniowa',
        subtitle: 'Zyskaj pewność, że w sytuacji ataku na Twoje zasoby IT masz wsparcie partnera, który zastosuje adekwatne procedury prawne i techniczne.',
        icon: 'icon05',
        content: {
            title: 'Obsługa incydentów i analiza powłamaniowa',
            subtitle: 'aby wesprzeć Cię w przypadku cyberataku',
            text: [
                'Incydenty związane z naruszeniem bezpieczeństwa danych wymagają szybkiej oraz przemyślanej reakcji obejmującej szereg działań <span class="offer-details-blue">prawnych i technicznych</span>, takich jak:',
                [
                    'potwierdzenie incydentu i jego przerwanie,',
                    'zabezpieczenie systemu i określenie skali ataku,',
                    'zebranie dowodów,',
                    'poinformowanie zainteresowanych stron, m.in. policji, inspektora danych osobowych, CERT (Computer Emergency Response Team) i CSIRT (Computer Security Incident Response Team).'
                ],
                'W czasach cyberzagrożeń warto mieć kogoś, na kim można zawsze polegać.'
            ]
        },
        cta: [{
            text: 'Działaj natychmiast, jeśli jesteś ofiarą cyberataku!',
            icon: 'act',
            pdf_lp: 'https://www.lemlock.com/procedury-reagowania-na-cyberataki/'
        }, {
            text: 'Pobierz broszurę',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/pl/Obsluga_incydentow_i_analiza_powlamaniowa.pdf`
        }]
    }, {
        slug: 'staff-training',
        title: 'Szkolenia personelu',
        subtitle: 'Przygotuj członków swojej organizacji do pracy zgodnej z zasadami bezpieczeństwa zarówno w kontekście prawnym, jak i technicznym.',
        icon: 'icon06',
        content: {
            title: 'Szkolenia personelu',
            subtitle: 'aby mieć pewność, że pracownicy będą realizować swoje zadania zgodnie ze standardami bezpieczeństwa i odpowiednio zareagują w sytuacji krytycznej',
            text: [
                'Aby zapewnić Twojej organizacji pełną zgodność z zasadami bezpieczeństwa i przepisami prawa (w tym także z RODO), zostaną przeprowadzone specjalne <span class="offer-details-blue">szkolenia dla personelu</span>.'
            ],
            list_numbered_title: 'Z obserwacji ekspertów Lemlock wynika, że w szkoleniach powinni obowiązkowo uczestniczyć:',
            list_numbered: [{
                icon: 'network',
                title: 'Administratorzy sieci',
                text: 'Aby wiedzieli, jak zarządzać sieciami i konfigurować je z uwzględnieniem aspektu bezpieczeństwa.'
            }, {
                icon: 'database',
                title: 'Deweloperzy oraz administratorzy baz danych',
                text: 'Aby pracowali w sposób odpowiedzialny i zapewniali aplikacjom, systemom czy bazom danych wysoki poziom ochrony podczas ich tworzenia, aktualizowania lub codziennego zarządzania.'
            }, {
                icon: 'nonTech',
                title: 'Personel nietechniczny',
                text: 'Aby jego przedstawiciele byli świadomi procedur, narzędzi oraz polityk, które zmniejszają ryzyko infiltracji organizacji.'
            }],
            bottom_text: [
                'Dzięki przeprowadzonym szkoleniom, osoby na wyżej wymienionych stanowiskach będą świadomie przestrzegać zasad związanych z bezpieczeństwem oraz wykonywać zadania w sposób nienarażający firmy na straty materialne/niematerialne.'
            ]
        },
        cta: [{
            text: 'Pobierz broszurę',
            icon: 'download',
            pdf_lp: `${ process.env.PUBLIC_URL }/pdfs/brochures/pl/Szkolenia_personelu.pdf`
        }, {
            text: 'Zapytaj o szczegóły',
            icon: 'ask',
            page: 'contact'
        }]
    }]
};



// WEBPACK FOOTER //
// ./src/i18n/pl/offer.js